import btnConfig from './btnConfig.vue';

export default btnConfig;
